import { createIcon } from "@chakra-ui/react";

export const BookFilled = createIcon({
  displayName: "BookFilled",
  viewBox: "0 0 24 24",
  path: [
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.75 4.686v14.619c1.402-.795 3.179-.904 4.819-.739 1.77.179 3.554.692 4.931 1.217V4.897c-1.328-.554-3.23-1.152-5.081-1.338-1.996-.202-3.689.094-4.669 1.127zM12 3.331C10.523 2.06 8.38 1.87 6.431 2.066 4.16 2.296 1.867 3.075.44 3.723a.75.75 0 0 0-.44.683v16.5a.75.75 0 0 0 1.06.683c1.323-.601 3.455-1.322 5.522-1.53 2.111-.213 3.884.13 4.832 1.316a.75.75 0 0 0 1.172 0c.948-1.186 2.72-1.53 4.833-1.316 2.066.208 4.198.929 5.52 1.53A.75.75 0 0 0 24 20.906v-16.5a.75.75 0 0 0-.44-.683c-1.427-.648-3.72-1.428-5.991-1.657-1.95-.196-4.092-.005-5.569 1.265z"
    />,
  ],
  defaultProps: {
    "aria-label": "An open two-page spread of a book "
  }
});

export default BookFilled;
